import type { ADFEntity } from '@atlaskit/adf-utils/types';

import type { BlocksSnippetAri } from '@atlassian/ari';

export enum SnippetProduct {
	// Only Confluence is allowed currently but more will be added:
	// 		https://bitbucket.org/atlassian/block-service/src/main/nebulae/seeding/ers/schemas
	CONFLUENCE = 'CONFLUENCE',
}
export enum SnippetBodyFormat {
	// Only ADF is allowed currently but more will be added:
	// 		https://bitbucket.org/atlassian/block-service/src/main/nebulae/seeding/ers/schemas
	ADF = 'ADF',
}

export enum SnippetStatus {
	ACTIVE = 'active',
	DELETED = 'deleted',
}

export enum SnippetEditorModalMode {
	CREATE = 'create',
	EDIT = 'edit',
	DUPLICATE = 'duplicate',
}

/** Define the source of the snippets */
export enum SnippetScope {
	GLOBAL = 'GLOBAL', // Atlassian-owned templates
	USER = 'USER', // My own created template
	SITE = 'SITE', // Site-wide templates that is shared with me
}

export const ATLASSIAN_ACCOUNT_ID = 'atlassian' as const;

export type UserSnippetOwner = {
	accountId: string;
	displayName: string;
	avatarUrl?: string;
};

export type AtlassianSnippetOwner = {
	accountId: typeof ATLASSIAN_ACCOUNT_ID;
	displayName: 'Atlassian';
};

export type SnippetOwner = UserSnippetOwner | AtlassianSnippetOwner;

// Transformed snippet data from the block service
export type Snippet = {
	ari: BlocksSnippetAri;
	snippetId: string; // uuidv7
	name: string;
	description?: string;
	bodyFormat: SnippetBodyFormat;
	body: ADFEntity | ADFEntity[];
	product: SnippetProduct;
	label?: string;
	isFavorite: boolean;
	status: SnippetStatus;
	scope: SnippetScope;
	/** When true, template is shared with the site (USER scope only from BE; SITE scope is always shared). */
	isShared: boolean;
	createdBy: SnippetOwner;
	createdAt: Date;
	updatedAt: Date;
	insertCount?: number;
};

export type SnippetFavorite = {
	userId: string;
	snippetIds: BlocksSnippetAri[];
};
